import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';

import { MsalInterceptor } from '@azure/msal-angular';
import { ConfirmationService, MessageService } from 'primeng/api';

import { AuthInterceptorService } from './interceptors/auth-interceptor.service';

@NgModule({
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    ConfirmationService,
    MessageService,
  ],
})
export class CoreModule {}
